import { render, staticRenderFns } from "./event-modal___1.vue?vue&type=template&id=8f0ccd3a&scoped=true"
import script from "./event-modal___1.vue?vue&type=script&lang=js"
export * from "./event-modal___1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f0ccd3a",
  null
  
)

export default component.exports